import { Modal } from "antd";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { PurchaseItemForm } from "./PurchaseItemForm";

const PurchaseItemModal = ({
  open,
  setOpen,
  existingItems = [],
  productionRefetch,
  purchaseRefetch,
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      footer={null}
      width={1200}
      centered
      destroyOnClose
      title={
        <div className="flex items-center bg-gray-200 p-2 rounded-md">
          <FaFileInvoiceDollar className="text-[18px] text-black " />
          <span className="text-[14px] font-[Poppins] text-black  ml-2">
            Add Purchase Item
          </span>
        </div>
      }
    >
      <PurchaseItemForm
        existingItems={existingItems}
        onCancel={handleClose}
        productionRefetch={productionRefetch}
        purchaseRefetch={purchaseRefetch}
      />
    </Modal>
  );
};

export default PurchaseItemModal;
